import { render, staticRenderFns } from "./ParEdenSpaceBar.vue?vue&type=template&id=52aca0c8&"
import script from "./ParEdenSpaceBar.vue?vue&type=script&lang=js&"
export * from "./ParEdenSpaceBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports